import React from 'react';
import '../../../assets/scss/components/Agent/VoiceMode.scss';

/**
 * Centered discovery CTA for live voice mode (before the user enters Realtime voice).
 */
const VoiceModePromo = ({ onStart }) => (
  <div className="voice-mode-promo" role="region" aria-label="Talk to Spacey live voice">
    <div className="voice-mode-promo__wave voice-mode-promo__wave--left" aria-hidden="true">
      {[0, 1, 2, 3, 4].map((i) => (
        <span key={i} className="voice-mode-promo__bar" style={{ animationDelay: `${i * 0.12}s` }} />
      ))}
    </div>

    <button
      type="button"
      className="voice-mode-promo__mic"
      onClick={onStart}
      aria-label="Talk to Spacey — start live voice"
    >
      <span className="voice-mode-promo__ring voice-mode-promo__ring--1" />
      <span className="voice-mode-promo__ring voice-mode-promo__ring--2" />
      <span className="voice-mode-promo__ring voice-mode-promo__ring--3" />
      <span className="voice-mode-promo__mic-inner">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M12 3a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3Z" fill="currentColor" />
          <path
            d="M5 11a7 7 0 0 0 14 0M12 18v3"
            stroke="currentColor"
            strokeWidth="1.75"
            strokeLinecap="round"
          />
        </svg>
      </span>
    </button>

    <div className="voice-mode-promo__wave voice-mode-promo__wave--right" aria-hidden="true">
      {[0, 1, 2, 3, 4].map((i) => (
        <span key={i} className="voice-mode-promo__bar" style={{ animationDelay: `${i * 0.12}s` }} />
      ))}
    </div>

    <p className="voice-mode-promo__title">Talk to Spacey</p>
    <p className="voice-mode-promo__subtitle">Tap to speak</p>
  </div>
);

export default VoiceModePromo;
